import { render, staticRenderFns } from "./berita.vue?vue&type=template&id=3c10e9b8&"
import script from "./berita.vue?vue&type=script&lang=js&"
export * from "./berita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports